import { useState, useContext, useEffect } from 'react'

import { TodoActionBox } from '.'
import { Filter, ChevronLeft } from '../../assets/icons'
import { Checkbox } from '../ui_new'
import { DocumentsContext, DocumentsFoldersContext } from '../../context'
import moment from 'moment'
import { ExpandMore } from '@mui/icons-material'

const TodoContentBox = ({ title, actions, type = 'task', loading = true, halfHeight = false, emptyLabel, color, onTitleClick = () => {}, sorted = false }) => {
  const { getTemplateById } = useContext(DocumentsContext)
  const { docFolders } = useContext(DocumentsFoldersContext)
  // const [showContent, setShowContent] = useState(false)
  const [allChecked, setAllChecked] = useState(false)
  const [sortOrder, setSortOrder] = useState('desc')
  const [sortedActions, setSortedActions] = useState([])

  useEffect(() => {
    if(sorted) {
      setSortedActions(actions)
      return
    }
    const sortActions = (order) => (a, b) => {
      let dateA
      let dateB
      if (a?.meta?.created) {
        dateA = moment(a.meta.created)
      } else if (a.createdAt) {
        dateA = moment(a.createdAt)
      }
      if (b?.meta?.created) {
        dateB = moment(b.meta.created)
      } else if (b.createdAt) {
        dateB = moment(b.createdAt)
      }
      if (Boolean(dateA) && Boolean(dateB)) {
        return (dateA.isBefore(dateB) && order === 'desc') ? 1 : -1
      } else if (Boolean(dateA)) {
        return 1
      } else if (Boolean(dateB)) {
        return -1
      }
    }

    let docs = actions
    docs.sort(sortActions(sortOrder))
    setSortedActions([...docs])
  }, [actions, sortOrder, sorted])

  return (
    <div className={`${halfHeight ? 'half-height' : ''}`}>
      <div className="todo-content-box__head">
        <div>
          <h2 className="title" onClick={onTitleClick}>
            {color && <span className={`circle ${color}`}></span>}
            <span>{title}</span>
          </h2>
          <div className="number">
            {loading ? <div className="loader-v2"></div> : actions.length}
          </div>
        </div>
      </div>
      <div className={`todo-content-box opened`}>

        {sortedActions.length > 0 && <div className="todo-content-box__body">
          {sortedActions.map((doc, actionIndex) => {
            return (
              <TodoActionBox
                key={`task-${doc.id}-event-${actionIndex}`}
                id={doc.id}
                task={doc}
                type={type}
              />
            )
          })}
        </div>}
        {sortedActions.length === 0 && <div className="y">
          <span className='no-document'>{emptyLabel || 'Aucune action'}</span>
        </div>}
      </div>
    </div>
  )
}

export default TodoContentBox
